document.addEventListener('DOMContentLoaded', function() {
  let lastScrollTop = 0;
  const header = document.querySelector('.header-wrapper');
  const body = document.body;
  
  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > lastScrollTop && scrollTop > 100) {
      // Scrolling down past the initial position
      body.classList.add('scrolled-down');
    } else {
      // Scrolling up
      body.classList.remove('scrolled-down');
    }
    
    lastScrollTop = scrollTop;
  });
});
